
















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AppealsEmail from "./AppealsEmail.vue";
@Component({
    components: {AppealsEmail}
})
export default class UseDelayRepay extends Vue {

    @Prop() bookingRef: string;
    @Prop() delayRepayAdviceUrl: string;

    mounted() {
        history.replaceState(null, 'Delay Repay is Appropriate - TrainSplit Refunds', '/Home/Disruption/Finished');
    }

    get appealsEmail() {
        return window.getAppealsEmail();
    }
}
